import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShow(true);
        setVisible(true);
      } else {
        // trigger exit animation
        setVisible(false);
        setTimeout(() => setShow(false), 300); // match duration
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!show) return null;

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-6 right-6 z-50
        w-12 h-12 rounded-full
        bg-gradient-to-b from-[#6cfcb5] to-[#F0FF6C]
        text-[#163031]
        flex items-center justify-center
        shadow-lg
        transition-all duration-300 ease-in-out
        hover:scale-110
        ${
          visible
            ? "opacity-100 translate-x-0"
            : "opacity-0 translate-x-20"
        }
      `}
      aria-label="Scroll to top"
    >
        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.9999 4.55961C10.9999 6.90009 8.77884 9.03321 6.33984 9.03321H5.33984V10.9532H6.33984C8.11384 10.9532 9.77784 10.2063 10.9999 9.03417V20.8796H12.9999V9.03417C14.2219 10.2063 15.8859 10.9532 17.6599 10.9532H18.6599V9.03321H17.6599C15.2209 9.03321 12.9999 6.90009 12.9999 4.55961V3.59961H10.9999V4.55961Z"
                          fill="currentColor"
                        />
                      </svg>
    </button>
  );
}
